import { render, staticRenderFns } from "./ObiTabs.vue?vue&type=template&id=333572eb&scoped=true&"
import script from "./ObiTabs.vue?vue&type=script&lang=js&"
export * from "./ObiTabs.vue?vue&type=script&lang=js&"
import style0 from "./ObiTabs.vue?vue&type=style&index=0&id=333572eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333572eb",
  null
  
)

export default component.exports